import { Point, Polygon } from '../context/context';
import { getAtlasApiBaseUrl } from './getAtlasApiBaseUrl';
import { atlasFetch } from './api/atlasBackendClient';

export type TravelMode = 'walking' | 'driving' | 'cycling' | 'transit';

const OPENROUTE_API_BASE_URL = `${getAtlasApiBaseUrl()}/api/openroute`;

// Use backend proxy for isochrone
export async function getIsochrone(
    point: Point,
    mode: TravelMode,
    time: number,
): Promise<Polygon> {
    const response = await atlasFetch(`${OPENROUTE_API_BASE_URL}/isochrone`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            point: point.coordinates, // [lat, lng]
            mode,
            time,
        }),
    });

    if (!response.ok) {
        const error = await response.text();
        throw new Error(`Backend OpenRouteService API error: ${error}`);
    }

    const { isochrone } = await response.json();
    // Convert the response to our Polygon format
    // OpenRouteService returns coordinates in [longitude, latitude] format
    // We need to convert to [latitude, longitude] and create a polygon
    const coordinates = isochrone.features[0].geometry.coordinates[0].map(
        (coord: [number, number]) => [coord[1], coord[0]] as [number, number]
    );

    return {
        id: `isochrone-${point.id}-${mode}-${time}`,
        type: 'polygon',
        name: `${mode.charAt(0).toUpperCase() + mode.slice(1)} ${time}min isochrone`,
        description: `Travel time area from ${point.name}`,
        colour: '#1976d2',
        opacity: '0.3',
        borderColour: '#1976d2',
        borderWidth: 2,
        isLocked: false,
        coordinates: [coordinates],
    };
}

// Use backend proxy for snapping points to roads
export async function snapPointsToRoads(points: [number, number][]): Promise<[number, number][]> {
    const response = await atlasFetch(`${OPENROUTE_API_BASE_URL}/snap-points`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ points }),
    });
    if (!response.ok) {
        throw new Error('Backend OpenRouteService snap-points API error');
    }
    const { snapped_points } = await response.json();
    return snapped_points;
}
